import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-[--border-soft] bg-bone">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-8 gap-10">
        <div className="md:col-span-2">
          <div className="font-serif text-4xl tracking-tighter leading-none mb-4">Ask<span className="text-klein">Winn</span>.</div>
          <p className="text-sm text-[--muted-foreground] max-w-sm leading-relaxed">
            India's managed marketplace for brand founders. Post a brief. Get competing bids from verified manufacturers.
          </p>
        </div>
        <div>
          <div className="overline mb-4">Platform</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/start" className="hover:text-klein transition-colors">Post an RFQ</Link></li>
            <li><Link to="/how-it-works" className="hover:text-klein transition-colors">Managed matching</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-klein transition-colors">About</Link></li>
            <li><Link to="/how-it-works" className="hover:text-klein transition-colors">How it works</Link></li>
            <li><Link to="/trust-safety" className="hover:text-klein transition-colors">Trust & safety</Link></li>
            <li><Link to="/contact" className="hover:text-klein transition-colors">Contact</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <div className="overline mb-4">Follow AskWinn</div>
          <ul className="space-y-2 text-sm">
            <li><a href="https://www.instagram.com/ask.winn/" target="_blank" rel="noreferrer" className="hover:text-klein transition-colors">Instagram</a></li>
            <li><a href="https://www.youtube.com/@AskWinn" target="_blank" rel="noreferrer" className="hover:text-klein transition-colors">YouTube</a></li>
            <li><a href="https://www.reddit.com/user/askwinn/" target="_blank" rel="noreferrer" className="hover:text-klein transition-colors">Reddit · u/askwinn</a></li>
            <li><a href="https://www.linkedin.com/company/askwinn/" target="_blank" rel="noreferrer" className="hover:text-klein transition-colors">LinkedIn</a></li>
            <li><a href="https://www.facebook.com/people/Askwinn/" target="_blank" rel="noreferrer" className="hover:text-klein transition-colors">Facebook</a></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <div className="overline mb-4">Contact</div>
          <ul className="space-y-2 text-sm">
            <li><a href="https://wa.me/918796132668" target="_blank" rel="noreferrer" className="hover:text-klein transition-colors">WhatsApp · +91 87961 32668</a></li>
            <li><a href="tel:+918796132668" className="hover:text-klein transition-colors">Call · +91 87961 32668</a></li>
            <li><a href="mailto:askwinnb2b@gmail.com" className="break-all hover:text-klein transition-colors">askwinnb2b@gmail.com</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[--border-soft]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
          <span className="font-mono text-xs text-[--muted-foreground]">© 2026 ASKWINN — MANUFACTURER SOURCING</span>
          <span className="font-mono text-xs text-[--muted-foreground]">MADE FOR FOUNDERS</span>
        </div>
      </div>
    </footer>
  );
}
